import {
  formatCents,
  formatCompetence,
  formatCostCenterRole,
} from "../../utils/directorFormat";

const CashflowBreakdown = ({
  competence,
  error = null,
  items = [],
  loading = false,
  onRetry,
}) => {
  if (!competence) return null;
  return <section className="director-section director-breakdown" aria-labelledby="cashflow-breakdown-title">
    <header>
      <div>
        <span className="director-eyebrow">Projeto e centro de custo</span>
        <h2 id="cashflow-breakdown-title">Composição de {formatCompetence(competence)}</h2>
      </div>
      <p>Selecione outra competência na tabela para atualizar este detalhamento.</p>
    </header>
    {loading && <div className="director-breakdown__state" role="status">Carregando composição da competência…</div>}
    {!loading && error && <div className="director-breakdown__state director-breakdown__state--error" role="alert">
      <strong>{error.message || "Não foi possível carregar a composição deste mês."}</strong>
      {error.retryable !== false && onRetry && <button className="director-button" type="button" onClick={onRetry}>
        Tentar detalhamento novamente
      </button>}
    </div>}
    {!loading && !error && items.length === 0 && <div className="director-breakdown__state">
      Nenhum movimento encontrado nesta competência para o recorte atual.
    </div>}
    {!loading && !error && items.length > 0 && <div className="director-table-scroll">
      <table className="director-table director-table--breakdown" aria-label="Composição do movimento por centro de custo">
        <thead>
          <tr>
            <th scope="col">Projeto</th>
            <th scope="col">Centro de custo</th>
            <th scope="col">Papel</th>
            <th scope="col">Entradas</th>
            <th scope="col">Saídas</th>
            <th scope="col">Fluxo líquido</th>
          </tr>
        </thead>
        <tbody>
          {items.map((item) => <tr key={`${item.legalEntityId}-${item.projectKey}-${item.costCenterId}`}>
            <th scope="row">{item.projectName}</th>
            <td>Centro {item.costCenterId}</td>
            <td>{formatCostCenterRole(item.role)}</td>
            <td>{formatCents(item.inflowCents)}</td>
            <td>{formatCents(item.outflowCents)}</td>
            <td>{formatCents(item.netFlowCents)}</td>
          </tr>)}
        </tbody>
      </table>
    </div>}
  </section>;
};

export default CashflowBreakdown;
